import axios from '../axios/axios-auth'

export default class ApontamentosService {

    getApontamentosByOrganization(orgId){
        return axios.get(`/appConfig/v1/organizations/${orgId}/stopReasons`).then(response => response.data)
    }

    addApontamentos(orgId, data){
        return axios.post(`/appConfig/v1/organizations/${orgId}/stopReasons`, data).then(response => response.data)
    }

    deleteApontamentos(stopCodeId) {
        return axios.delete(`/appConfig/v1/stopReasons/${stopCodeId}`).then(response => response.data)
    }

}
